import React from 'react';
import PropTypes from 'prop-types';

import styles from './nextAvailable.scss';

const HeaderCount = (props) => {
    const {
        className,
        label,
        value,
        'data-testid': dataTestId,
    } = props;
    return (
        <div className={`${styles.headerCount} ${className}`} data-testid={dataTestId}>
            <div className={styles.label} data-testid={dataTestId && `${dataTestId}.label`}>
                {label}
            </div>
            <div className={styles.count} data-testid={dataTestId && `${dataTestId}.value`}>
                {value}
            </div>
        </div>
    );
};

HeaderCount.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'data-testid': PropTypes.string,
};

HeaderCount.defaultProps = {
    className: '',
    value: 0,
    'data-testid': undefined,
};

export default HeaderCount;
